<template>
    <div class="full-screen">
        <div class="operation-bar">
            <h1>{{title}}</h1>
            <div class="operation-bar-right">
                <div class="input-box">
                    <i></i>
                    <input type="text" v-model="orderNo" placeholder="请输入订单号"/>
                </div>
                <div class="input-box">
                    <i class="el-icon-search" @click="queryByCondition"></i>
                    <input type="text" v-model="mtrlName" placeholder="请输入物料名称"/>
                </div>
                <a href="javascript:void(0)" @click="closeSendDetail">返回</a>
            </div>
        </div>
        <el-table :data="noSendOrderDetailList"
                  height="calc(100% - 35px)"
                  @row-dblclick = "rowDblclick"
                  :highlight-current-row = "true"
                  ref="table"
                  v-loading = "topLoading"
                  :header-cell-style="{background:'#4885CA', color: 'white'}">
            <el-table-column width="110" property="orderNo" label="采购订单号"  align="center" header-align="center" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column width="110" property="rowNo" label="采购行项目"  align="center" header-align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{scope.row.sapSaleOrderRowNo === '0'?'':scope.row.sapSaleOrderRowNo}}</span>
                </template>
            </el-table-column>
            <el-table-column width="110" property="sapSaleOrderNo" label="销售订单号"  align="center" header-align="center" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column width="110" property="sapSaleOrderRowNo" label="销售行项目"  align="center" header-align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{scope.row.sapSaleOrderRowNo === '0'?'':scope.row.sapSaleOrderRowNo}}</span>
                </template>
            </el-table-column>
            <el-table-column  width="120" label="物料编码" align="center" header-align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{scope.row.sapMtrlCode.substr(-10,10)}}</span>
                </template>
            </el-table-column>
            <el-table-column width="300" property="sapMtrlName" label="物料名称"  align="center" header-align="center" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column width="200"  property="compName" label="采购方" align="center" header-align="center" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column property="expectDate" width="100" label="交货日期" align="center" header-align="center">
                <template slot-scope="scope">
                    {{dateFormat(scope.row.expectDate)}}
                </template>
            </el-table-column>
            <el-table-column label="订单数量" width="90" align="center" header-align="center">
                <template slot-scope="scope">
                    <span style="color: blueviolet">{{scope.row.qty}}</span>
                </template>
            </el-table-column>
            <el-table-column property="sendQty" width="90" label="待发数量" align="center" header-align="center">
                <template slot-scope="scope">
                    <span style="color: red">{{scope.row.qty- scope.row.expectDqty}}</span>
                </template>
            </el-table-column>
            <el-table-column property="uom" width="90" label="计量单位"  align="center" header-align="center">
            </el-table-column>
            <el-table-column property="price" width="90" label="单价" align="center" header-align="center">
            </el-table-column>
            <el-table-column property="sapTaxCode" width="70" label="税码" align="center" header-align="center">
            </el-table-column>
            <el-table-column property="sapTaxCodeDesc" width="120" label="税码描述" align="center" header-align="center" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column width="150" property="vendorRemark" label="沟通备注" align="center" header-align="center" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column property="ownerRemark" label="采购方备注" align="center" header-align="center" :show-overflow-tooltip="true">
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.current"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.total">
        </el-pagination>
        <el-dialog
                title="发货确认"
                :visible.sync="sendDialogShowFlag"
                width="30%"
                @close="sendDialogClose"
        >
            <el-form label-width="80px">
                <el-form-item label="物料编号">
                    <el-input v-model="currentSelectRow.sapMtrlCode" disabled></el-input>
                </el-form-item>
                <el-form-item label="物料名称">
                    <el-input v-model="currentSelectRow.sapMtrlName" disabled></el-input>
                </el-form-item>
                <el-form-item label="单价">
                    <el-input v-model="currentSelectRow.price" disabled></el-input>
                </el-form-item>
                <el-form-item label="数量">
                    <el-input-number v-model="sendQty" :precision="2" :min="0" :max="(maxSendQty)"></el-input-number>
                    {{currentSelectRow.uom}}
                </el-form-item>
                <el-form-item label="金额">
                    {{sendQty * currentSelectRow.price}}
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sendDialogClose">取 消</el-button>
                <el-button type="primary" @click="saveSendDetail">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import dayjs from 'dayjs'
    export default {
        name: 'topTable',
        props: ['noSendOrderDetailList', 'isLock', 'topLoading', 'page'],
        data() {
            return {
                orderNo: '',
                mtrlName: '',
                sendQty: 1,
                currentSelectRow: {},
                maxSendQty: '',
                sendDialogShowFlag: false,
                title: '待发货订单明细',
            }
        },
        methods: {
            queryByCondition() {
                this.$emit('queryByCondition', {orderNo: this.orderNo, mtrlName: this.mtrlName});
            },
            handleSizeChange(val) {
                this.$emit('handleSizeChange', val);
            },
            handleCurrentChange(val) {
                this.$emit('handleCurrentChange', val);
            },
            rowDblclick(row) {
                if(!this.isLock){
                    this.currentSelectRow = row;
                    this.maxSendQty = row.qty- row.expectDqty;
                    this.sendQty = this.maxSendQty;
                    this.sendDialogShowFlag = true;
                }else{
                    this.$message.warning("当前发货单已提交，无法继续添加明细")
                }
            },
            sendDialogClose() {
                this.sendDialogShowFlag = false;
            },
            saveSendDetail() {
                let param = {};
                param.orderDetailId = this.currentSelectRow.id;
                param.qty = this.sendQty;
                this.$emit('saveSendDetail', param);
                this.sendDialogShowFlag = false;
            },
            closeSendDetail() {
                this.$emit("closeSendDetail");
            },
            dateFormat(val) {
                if (val) {
                    return dayjs(val).format('YYYY-MM-DD ');
                } else {
                    return '';
                }
            },
        }
    }
</script>
<style scoped>
</style>
